// extracted by mini-css-extract-plugin
export var icon = "UspItem-module--icon--69e63";
export var item = "UspItem-module--item--2dd2f";